import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const GoodsReceiptService = {

  getAllGR: async () => {
    try {
      const response = await axios.get(ENDPOINT.GoodsReceipt);
      return response.data;
    } catch (error) {
      console.error("Error fetching Goods Receipts:", error.message);
      throw error;
    }
  },

  getGRStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.GoodsReceipt}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching GR stats:", error.message);
      throw error;
    }
  },

  getLastGR: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.GoodsReceipt}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last GR:", error.message);
      throw error;
    }
  },

getDistinctValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.GoodsReceipt}/distinct/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching distinct values:", error.message);
      throw error;
    }
  },

getGRByPOId: async (po_id) => {
    try {
      const response = await axios.get(`${ENDPOINT.GoodsReceipt}/by-po/${po_id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching GRs by PO:", error.message);
      throw error;
    }
  },

  getReceivedQtyByItem: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.GoodsReceipt}/received-qty-by-item`);
      return response.data;
    } catch (error) {
      console.error("Error fetching received qty by item:", error.message);
      throw error;
    }
  },

  getGRById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.GoodsReceipt}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching GR:", error.message);
      throw error;
    }
  },

  createGR: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.GoodsReceipt, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating GR:", error.message);
      throw error;
    }
  },

  updateGR: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.GoodsReceipt}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating GR:", error.message);
      throw error;
    }
  },

  deleteGR: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.GoodsReceipt}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting GR:", error.message);
      throw error;
    }
  },
};